import { gql } from "@apollo/client";

/**
 * Save the unified chrome config JSON to chrome_config_draft.
 */
export const SAVE_CHROME_CONFIG = gql`
  mutation SaveChromeConfig($config: String!) {
    saveChromeConfig(config: $config) {
      id
      chromeConfigDraft
    }
  }
`;

/**
 * Publish: copy chrome_config_draft to chrome_config_published.
 * The legacy nav_config / footer_config / announcement_config columns are
 * deliberately NOT touched — they stay frozen as the legacy site's chrome.
 */
export const PUBLISH_CHROME_CONFIG = gql`
  mutation PublishChromeConfig {
    publishChromeConfig {
      id
      chromeConfigDraft
      chromeConfigPublished
      navConfig
      footerConfig
      announcementConfig
    }
  }
`;
